// Shared layout + UI tokens for the artist portfolio (amber cinematic theme)
export const artistPagePad = 'px-4 sm:px-6 lg:px-8';
export const artistPageWidth = 'max-w-7xl mx-auto w-full';

export const artistBtnPrimary =
  'inline-flex items-center justify-center gap-2 rounded-full bg-amber-200 px-7 py-3 text-sm font-semibold text-black transition-colors hover:bg-amber-100 disabled:cursor-not-allowed disabled:bg-white/20 disabled:text-white/40 sm:px-8 sm:text-base';

export const artistBtnSecondary =
  'inline-flex items-center justify-center gap-2 rounded-full border border-white/35 px-7 py-3 text-sm font-semibold text-white/90 transition-colors hover:border-white/70 hover:text-white sm:px-8 sm:text-base';

export const artistBtnGhost =
  'inline-flex items-center justify-center gap-2 rounded-full border border-white/20 bg-white/5 px-5 py-2.5 text-sm font-semibold text-white/80 transition-colors hover:border-amber-200/40 hover:text-amber-100';

export const artistHeadingAccent = 'text-amber-200';

/** Elevated charcoal cards on black (subtle edge highlight, not amber wash) */
export const artistSurfaceCard =
  'rounded-2xl border border-white/12 bg-[#1a1e23] p-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.06)] sm:p-8';

export const artistSurfaceInset =
  'rounded-xl border border-white/10 bg-[#12151a]';
